export default function initOldSections() {
    const sections = [].slice.apply(document.querySelectorAll('.oldSections-section'));

    sections.forEach(section => {

        const listEl = section.querySelector('.oldSections-feature-list');

        if (listEl && listEl.classList.contains('method-accordion')) {
            const entries = [].slice.apply(listEl.querySelectorAll('dt')).map(dt => {
                let nextSibling = dt.nextSibling;
                while (nextSibling && nextSibling.nodeType !== 1) {
                    nextSibling = nextSibling.nextSibling;
                }
                return {
                    dt,
                    dd: nextSibling,
                };
            });
            entries.forEach(({ dt, dd }) => {
                dt.classList.add('s-hidden');
                dd.style.height = 0;
                dt.addEventListener('click', toggle);

                window.addEventListener('resize', onResize);
                window.addEventListener('orientationchange', onResize);

                function toggle() {
                    if (dt.classList.contains('s-hidden')) {
                        dd.style.height = dd.scrollHeight + 'px';
                        dt.classList.remove('s-hidden');
                    } else {
                        dd.style.height = 0;
                        dt.classList.add('s-hidden');
                    }
                }

                function onResize() {
                    if (!dt.classList.contains('s-hidden')) {
                        dd.style.height = dd.scrollHeight + 'px';
                    }
                }
            });
        }
    });
}
